/** The area this app has data for. */
export const IDF_BOUNDS: [[number, number], [number, number]] = [
  [1.2, 47.95],
  [3.8, 49.4],
];

/**
 * Is this point somewhere the app can actually show?
 *
 * The map is clamped to `IDF_BOUNDS`, so flying to anywhere outside them does
 * nothing at all — which reads as a broken control rather than as "we do not
 * cover Lille". Anything that offers the user a place to jump to should check
 * first.
 */
export function withinIdf(lon: number, lat: number): boolean {
  const [[west, south], [east, north]] = IDF_BOUNDS;
  return lon >= west && lon <= east && lat >= south && lat <= north;
}
